import { useQuery } from "@tanstack/react-query";
import JsdhNotifikaceService, { ReportFilterParams } from "./JsdhNotifikaceService";
import type { OsobniStatistikaResponse } from "../generated/models/OsobniStatistika";
import type { ReportSouhrn } from "../generated/models/ReportSouhrn";
import type { ReportDetail } from "../generated/models/ReportDetail";

/**
 * Hook pro načtení osobních statistik přihlášeného uživatele.
 */
export const useOsobniStatistikaQuery = (params?: ReportFilterParams, enabled?: boolean) => {
    return useQuery<OsobniStatistikaResponse, Error>({
        queryKey: ["osobniStatistika", params],
        queryFn: () => JsdhNotifikaceService.getOsobniStatistika(params),
        enabled: enabled !== undefined ? enabled : true,
        staleTime: 60000, // 1 minuta
    });
};

/**
 * Hook pro načtení statistik konkrétního uživatele (admin only).
 */
export const useStatistikaUzivateleQuery = (userId: number | null, params?: ReportFilterParams) => {
    return useQuery<OsobniStatistikaResponse, Error>({
        queryKey: ["statistikaUzivatele", userId, params],
        queryFn: () => JsdhNotifikaceService.getStatistikaUzivatele(userId!, params),
        enabled: !!userId,
        staleTime: 60000,
    });
};

/**
 * Hook pro načtení souhrnného reportu za dané období.
 */
export const useReportSouhrnQuery = (params?: ReportFilterParams) => {
    return useQuery<ReportSouhrn, Error>({
        queryKey: ["reportSouhrn", params],
        queryFn: () => JsdhNotifikaceService.getReportSouhrn(params),
        staleTime: 60000, // 1 minuta
    });
};

/**
 * Hook pro načtení plného detailu reportu za dané období.
 */
export const useReportDetailQuery = (params?: ReportFilterParams) => {
    return useQuery<ReportDetail, Error>({
        queryKey: ["reportDetail", params],
        queryFn: () => JsdhNotifikaceService.getReportDetail(params),
        staleTime: 60000, // 1 minuta
    });
};
